stateProviders.push({
    name: 'schoolside.resources.information.parentIntro',
    url: '/parentIntro',
    templateUrl: 'fast/submodules/schoolside/resources/information/parentIntro/partials/parentIntro.html?v=' + versionNo,
    controller: 'parentIntroController',
    resolve: {
    }
});